// app/features/inquiries/inquiriesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InquiriesState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: InquiriesState = {
  loading: false,
  error: null,
  success: false,
};

const inquiriesSlice = createSlice({
  name: "inquiries",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
        state.success = false;
      }
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setSuccess(state, action: PayloadAction<boolean>) {
      state.success = action.payload;
    },
    submitInquiryStart(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    submitInquirySuccess(state) {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    submitInquiryFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetInquiryState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  setLoading,
  setError,
  setSuccess,
  submitInquiryStart,
  submitInquirySuccess,
  submitInquiryFailure,
  resetInquiryState,
} = inquiriesSlice.actions;

export default inquiriesSlice.reducer;